export const en = {
    'add-creatives': 'Add selected creatives',
    'cancel-and-return': 'Cancel'
};
